/** Analytics actions stored in core-v1 audit.payment_page_statistics (payment_page_action_enum). */
export type PaymentPageTrackAction =
  | 'PAGE_LOADED'
  | 'SOCKET_CONNECTION_FAILED'
  | 'FORM_COPY_REQUISITE_1_CLICKED'
  | 'FORM_COPY_REQUISITE_2_CLICKED'
  | 'FORM_COPY_REQUISITE_3_CLICKED'
  | 'FORM_COPY_AMOUNT_CLICKED'
  | 'FORM_COPY_BANK_NAME_CLICKED'
  | 'CHECK_UTR_EXIST_TRUE'
  | 'CHECK_UTR_EXIST_FALSE'
  | 'FORM_INPUT_CLICKED'
  | 'FORM_INPUT_FILLED'
  | 'FORM_INPUT_PASTED'
  | 'FORM_CONFIRM_BUTTON_CLICKED';

export const PAYMENT_PAGE_REQ_TYPE_TRACK_ACTION = 'TRACK_ACTION' as const;

/** Copy-section elements: assign which analytics action fires on copy click. */
export const COPY_SECTION_TRACK_ACTIONS: PaymentPageTrackAction[] = [
  'FORM_COPY_REQUISITE_1_CLICKED',
  'FORM_COPY_REQUISITE_2_CLICKED',
  'FORM_COPY_REQUISITE_3_CLICKED',
  'FORM_COPY_AMOUNT_CLICKED',
  'FORM_COPY_BANK_NAME_CLICKED',
];

/** Button elements: assign confirm-button analytics action. */
export const BUTTON_TRACK_ACTIONS: PaymentPageTrackAction[] = ['FORM_CONFIRM_BUTTON_CLICKED'];
